module.exports = __webpack_public_path__ + "static/inside-6e9afa8310de7e4066af001a9d41ab1d.jpg";